<template>
  <div class="descripcion">
    <input-comp label="Descripción" v-model="descripcion" :required="true" />
  </div>
</template>

<script>
  import InputComp from "../../../../Componentes_Globales/Input/inputComp";

  export default {
    name: "Descripcion",
    components: {InputComp},
    computed: {
      descripcion: {
        get() {
          return this.$store.state.producto.producto.descripcion
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "descripcion", value: value.toUpperCase()})
        }
      }
    }
  }
</script>

<style scoped>

</style>
